import FormattedMessage from 'I18n/components/FormattedMessage';
import UILockBadge from 'UIComponents/badge/UILockBadge';
import UIButton from 'UIComponents/button/UIButton';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function EnterpriseConversionReportingUpgradePoint() {
  const {
    openUpgradeModal
  } = useUpgradeModal('enterprise-conversion-reporting');
  return /*#__PURE__*/_jsxs(UIButton, {
    onClick: openUpgradeModal,
    use: "tertiary-light",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.enrollmentConversion.panel.tracking-toggle.buttonText"
    }), /*#__PURE__*/_jsx(UILockBadge, {})]
  });
}
export default EnterpriseConversionReportingUpgradePoint;